/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
interface MastercardIconProps {
    className?: string;
    width?: number | string;
    height?: number | string;
}

export default function MastercardIcon(props: MastercardIconProps) {
    return (
        <svg viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.5" y="0.5" width="37" height="21" rx="3.5" fill="white" />
            <path d="M15.5242 5.10352H22.7436V16.895H15.5242V5.10352Z" fill="#FF5F00" />
            <path
                d="M16.2679 11.0009C16.267 9.8655 16.5244 8.74476 17.0206 7.72351C17.5168 6.70226 18.2388 5.80726 19.1319 5.10624C18.0257 4.23687 16.6972 3.69626 15.2983 3.5462C13.8994 3.39613 12.4864 3.64267 11.221 4.25763C9.95557 4.87259 8.88867 5.83116 8.14225 7.02379C7.39583 8.21642 7 9.59499 7 11.0019C7 12.4089 7.39583 13.7875 8.14225 14.9801C8.88867 16.1727 9.95557 17.1313 11.221 17.7462C12.4864 18.3612 13.8994 18.6077 15.2983 18.4577C16.6972 18.3076 18.0257 17.767 19.1319 16.8976C18.2385 16.1964 17.5163 15.3011 17.0201 14.2794C16.5239 13.2578 16.2667 12.1366 16.2679 11.0009V11.0009Z"
                fill="#EB001B"
            />
            <path
                d="M30.5485 15.6476V15.406H30.6526V15.356H30.4048V15.406H30.5027V15.6476L30.5485 15.6476ZM31.0296 15.6476V15.356H30.9547L30.8672 15.5643L30.7797 15.356H30.7047V15.6476H30.7589V15.4268L30.8401 15.6164H30.8963L30.9776 15.4268V15.6476H31.0296Z"
                fill="#F79E1B"
            />
            <path
                d="M31.2649 11.0005C31.2648 12.4075 30.8689 13.7862 30.1224 14.9789C29.3758 16.1715 28.3087 17.1301 27.0431 17.7449C25.7775 18.3598 24.3645 18.6062 22.9655 18.4559C21.5665 18.3056 20.238 17.7647 19.1318 16.8951C20.0246 16.1935 20.7464 15.2982 21.2427 14.2769C21.7391 13.2556 21.9969 12.1349 21.9969 10.9994C21.9969 9.86389 21.7391 8.7432 21.2427 7.7219C20.7464 6.70059 20.0246 5.80535 19.1318 5.1037C20.238 4.23406 21.5665 3.69318 22.9655 3.5429C24.3645 3.39261 25.7776 3.63899 27.0432 4.25387C28.3088 4.86874 29.3758 5.8273 30.1224 7.01998C30.8689 8.21266 31.2648 9.59132 31.2649 10.9984V11.0005Z"
                fill="#F79E1B"
            />
            <rect x="0.5" y="0.5" width="37" height="21" rx="3.5" stroke="#DDDDDD" />
        </svg>
    );
}
